import React from "react";
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer footer-four">
      {/* Footer Top */}
      <div className="footer-top aos" data-aos="fade-up">
        <div className="container">
          <div className="row">
            {/* Footer Contact */}
         <div className="col-lg-3">
<div className="footer-contact footer-widget">
  <div className="footer-logo">
    <img src="/images/6.jpg" className="img-fluid aos" alt="SR Cab Service logo" />
  </div>

  <div className="footer-contact-info">
    <p className="text-white">
      SR Cab Service provides reliable and comfortable transportation for all your needs. 
      Our fleet includes compact cars, sedans, SUVs, and luxury vehicles to ensure a smooth ride.
    </p>

    <p>
      <strong className="text-white">Phone:</strong> 
      <a href="tel:+919011955415"> +91 90119 55415</a><br />

      <strong className="text-white">Email:</strong> 
      <a href="mailto:booking@srscabservice.com"> booking@srscabservice.com</a><br />

      <strong className="text-white">Address:</strong> 
      <span className="text-white">
        {" "}Office no. 3 Mankar Corner, Kaspate Chowk, Wakad, Pune 411027
      </span>
    </p>
  </div>

  <iframe
    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2713.1265851410503!2d73.77091777519333!3d18.590460082516735!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTjCsDM1JzI1LjciTiA3M8KwNDYnMjQuNiJF!5e1!3m2!1sen!2sin!4v1774268184715!5m2!1sen!2sin"
    width="100%"
    height="250"
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  ></iframe>
</div>
</div>

            {/* Footer Menus */}
            {/* <div className="col-lg-7"> */}
              {/* <div className="row"> */}
                <div className="col-12 col-md-3">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title"> Our Services</h5>
                   <Link className="mx-md-2 d-block" to="/Pune-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune Cab Service</Link>
<Link className="mx-md-2 d-block" to="/Pune-Taxi-Hire"><i className="fa fa-car darkcolor"></i> Pune Taxi Hire</Link>
<Link className="mx-md-2 d-block" to="/Pune-Online-Cabs-Booking"><i className="fa fa-car darkcolor"></i> Pune Online Cabs Booking</Link>
<Link className="mx-md-2 d-block" to="/Best-Cabs-Service-in-Pune"><i className="fa fa-car darkcolor"></i> Best Cabs Service in Pune</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Nasik-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Nasik Cabs</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Mahabaleshwar-Cab"><i className="fa fa-car darkcolor"></i> Pune to Mahabaleshwar Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Lonavala-Cab"><i className="fa fa-car darkcolor"></i> Pune to Lonavala Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Trimbakeshwar-Cab"><i className="fa fa-car darkcolor"></i> Pune to Trimbakeshwar Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Shirdi-Cab"><i className="fa fa-car darkcolor"></i> Pune to Shirdi Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Bhimashankar-Cab"><i className="fa fa-car darkcolor"></i> Pune to Bhimashankar Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Indore-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Indore Cabs</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Konkan-Darshan-Cab"><i className="fa fa-car darkcolor"></i> Pune to Konkan Darshan Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-Cab-Fare"><i className="fa fa-car darkcolor"></i> Pune Cab Fare</Link>
<Link className="mx-md-2 d-block" to="/Pune-Outstation-Cabs"><i className="fa fa-car darkcolor"></i> Pune Outstation Cabs</Link>
                                   <Link className="mx-md-2 d-block" to="/Pune-to-Panchgani-Cab"><i className="fa fa-car darkcolor"></i> Pune to Panchgani Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-International-Airport-Cab"><i className="fa fa-car darkcolor"></i> Pune to Mumbai International Airport Cab</Link>
<Link className="mx-md-2 d-block" to="/Ashtavinayak-Darshan-Cab"><i className="fa fa-car darkcolor"></i> Ashtavinayak Darshan Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Nagpur-Cab"><i className="fa fa-car darkcolor"></i> Pune to Nagpur Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Goa-Cab"><i className="fa fa-car darkcolor"></i> Pune to Goa Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Ajanta-Ellora-Cab"><i className="fa fa-car darkcolor"></i> Pune to Ajanta Ellora Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Satara-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Satara Cabs</Link>
<Link className="mx-md-2 d-block" to="/Pune-Airport-Cabs"><i className="fa fa-car darkcolor"></i> Pune Airport Cabs</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Ayodhya-Tour-Package"><i className="fa fa-car darkcolor"></i> Pune to Ayodhya Tour Package</Link>
<Link className="mx-md-2 d-block" to="/Corporate-Cab-Service-in-Pune"><i className="fa fa-car darkcolor"></i> Corporate Cab Service in Pune</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-Airport-Cab"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Airport Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Kolhapur-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Kolhapur Cabs</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Pandharpur-Taxi"><i className="fa fa-car darkcolor"></i> Pune to Pandharpur Taxi</Link>
<Link className="mx-md-2 d-block" to="/Tempo-Traveller-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Tempo Traveller On Rent in Pune</Link>
<Link className="mx-md-2 d-block" to="/Urbania-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Urbania On Rent in Pune</Link>
<Link className="mx-md-2 d-block" to="/Innova-Crysta-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Innova Crysta On Rent in Pune</Link>
<Link className="mx-md-2 d-block" to="/Innova-Cabs-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Innova Cabs on Rent in Pune</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Ujjain-Cab"><i className="fa fa-car darkcolor"></i> Pune to Ujjain Cab</Link>
<Link className="mx-md-2 d-block" to="/Swift-Dzire-On-Rent-In-Pune"><i className="fa fa-car darkcolor"></i> Swift Dzire On Rent In Pune</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Somnath-Jyotirlinga-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Somnath Jyotirlinga Cab Service</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Imagica-Cab"><i className="fa fa-car darkcolor"></i> Pune to Imagica Cab</Link>
<Link className="mx-md-2 d-block" to="/Mini-Bus-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Pune</Link>
<Link className="mx-md-2 d-block" to="/Ertiga-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Ertiga On Rent in Pune</Link>
<Link className="mx-md-2 d-block" to="/Kia-Carens-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Kia Carens On Rent in Pune</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Sambhaji-Nagar-Taxi-fare"><i className="fa fa-car darkcolor"></i> Pune to Sambhaji Nagar Taxi fare</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Ganpatipule-Taxi"><i className="fa fa-car darkcolor"></i> Pune to Ganpatipule Taxi</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Akkalkot-Cab"><i className="fa fa-car darkcolor"></i> Pune to Akkalkot Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Alibag-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Alibag Cabs</Link>

                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title"> Our Services</h5>
<Link className="mx-md-2 d-block" to="/Pune-to-Panvel-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Panvel Cabs</Link>

                  <Link className="mx-md-2 d-block" to="/Pune-to-Hyderabad-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Hyderabad Cabs</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Bangalore-Taxi-Service"><i className="fa fa-car darkcolor"></i> Pune to Bangalore Taxi Service</Link>
<Link className="mx-md-2 d-block" to="/One-Way-Cab-Pune"><i className="fa fa-car darkcolor"></i> One Way Cab Pune</Link>
<Link className="mx-md-2 d-block" to="/Taxi-Service-in-Hadapsar"><i className="fa fa-car darkcolor"></i> Taxi Service in Hadapsar</Link>
<Link className="mx-md-2 d-block" to="/Taxi-Service-in-Lohegaon"><i className="fa fa-car darkcolor"></i> Taxi Service in Lohegaon</Link>
<Link className="mx-md-2 d-block" to="/Cab-Service-in-Viman-Nagar"><i className="fa fa-car darkcolor"></i> Cab Service in Viman Nagar</Link>
                  <Link className="mx-md-2 d-block" to="/Cab-Service-in-Kharadi"><i className="fa fa-car darkcolor"></i> Cab Service in Kharadi</Link>
<Link className="mx-md-2 d-block" to="/Taxi-Service-in-Hinjewadi-Pune"><i className="fa fa-car darkcolor"></i> Taxi Service in Hinjewadi Pune</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Gujarat-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Gujarat Cab Service</Link>


<Link className="mx-md-2 d-block" to="/Travel-Agents-in-Pune"><i className="fa fa-car darkcolor"></i> Travel Agents in Pune</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Thane-Cab"><i className="fa fa-car darkcolor"></i> Pune to Thane Cab</Link>
<Link className="mx-md-2 d-block" to="/Outstation-Taxi-Service-Pune"><i className="fa fa-car darkcolor"></i> Outstation Taxi Service Pune</Link>
<Link className="mx-md-2 d-block" to="/Cab-Booking-in-Pune"><i className="fa fa-car darkcolor"></i> Cab Booking in Pune</Link>
<Link className="mx-md-2 d-block" to="/Online-Cab-Booking-Pune"><i className="fa fa-car darkcolor"></i> Online Cab Booking Pune</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-One-Way-Cab"><i className="fa fa-car darkcolor"></i> Pune to Mumbai One Way Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-Mumbai-Car-Hire"><i className="fa fa-car darkcolor"></i> Pune Mumbai Car Hire</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-Online-Cab-Booking"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Online Cab Booking</Link>
<Link className="mx-md-2 d-block" to="/Pimpri-Chinchwad-to-Mumbai-Cabs"><i className="fa fa-car darkcolor"></i> Pimpri Chinchwad to Mumbai Cabs</Link>
<Link className="mx-md-2 d-block" to="/Baner-to-Mumbai-Cabs"><i className="fa fa-car darkcolor"></i> Baner to Mumbai Cabs</Link>
<Link className="mx-md-2 d-block" to="/Hinjewadi-to-Mumbai-Cabs"><i className="fa fa-car darkcolor"></i> Hinjewadi to Mumbai Cabs</Link>
<Link className="mx-md-2 d-block" to="/Pimple-Saudagar-to-Mumbai-Cab-Service"><i className="fa fa-car darkcolor"></i> Pimple Saudagar to Mumbai Cab Service</Link>
<Link className="mx-md-2 d-block" to="/Wakad-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Wakad to Mumbai Cab</Link>
<Link className="mx-md-2 d-block" to="/Hadapsar-to-Mumbai-Cabs"><i className="fa fa-car darkcolor"></i> Hadapsar to Mumbai Cabs</Link>
 <Link className="mx-md-2 d-block" to="/Kalyani-Nagar-to-Mumbai-Taxi"><i className="fa fa-car darkcolor"></i> Kalyani Nagar to Mumbai Taxi</Link>
<Link className="mx-md-2 d-block" to="/Koregaon-Park-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Koregaon Park to Mumbai Cab</Link>
<Link className="mx-md-2 d-block" to="/Kothrud-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Kothrud to Mumbai Cab</Link>
<Link className="mx-md-2 d-block" to="/Kharadi-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Kharadi to Mumbai Cab</Link>
<Link className="mx-md-2 d-block" to="/Shivajinagar-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Shivajinagar to Mumbai Cab</Link>
<Link className="mx-md-2 d-block" to="/Pune-to-Mumbai-Ertiga-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Ertiga Cabs</Link>
<Link className="mx-md-2 d-block" to="/Kondhwa-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Kondhwa to Mumbai Cab</Link>
   <Link className="mx-md-2 d-block" to="/Viman-Nagar-to-Mumbai-Cabs"><i className="fa fa-car darkcolor"></i> Viman Nagar to Mumbai Cabs</Link>
<Link className="mx-md-2 d-block" to="/Katraj-to-Mumbai-Cab-Service"><i className="fa fa-car darkcolor"></i> Katraj to Mumbai Cab Service</Link>
    <Link className="mx-md-2 d-block" to="/Pune-Station-to-Mumbai-Cabs-Service"><i className="fa fa-car darkcolor"></i> Pune Station to Mumbai Cabs Service</Link>
<Link className="mx-md-2 d-block" to="/Boat-Club-Road-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Boat Club Road to Mumbai Cab</Link>
<Link className="mx-md-2 d-block" to="/Vishrantwadi-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Vishrantwadi to Mumbai Cab</Link>
<Link className="mx-md-2 d-block" to="/Alandi-to-Mumbai-Cabs-Service"><i className="fa fa-car darkcolor"></i> Alandi to Mumbai Cabs Service</Link>
<Link className="mx-md-2 d-block" to="/Wagholi-to-Mumbai-Cab"><i className="fa fa-car darkcolor"></i> Wagholi to Mumbai Cab</Link>
<Link className="mx-md-2 d-block" to="/Cab-Service-in-Pimpri-Chinchwad"><i className="fa fa-car darkcolor"></i> Cab Service in Pimpri Chinchwad</Link>
<Link className="mx-md-2 d-block" to="/Cab-Service-in-Chinchwad"><i className="fa fa-car darkcolor"></i> Cab Service in Chinchwad</Link>
<Link className="mx-md-2 d-block" to="/Cab-Service-in-Bhosari"><i className="fa fa-car darkcolor"></i> Cab Service in Bhosari</Link>

                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title"> Our Services</h5>
<Link className="mx-md-2 d-block" to="/Cab-Service-in-Nigdi-Pradhikaran"><i className="fa fa-car darkcolor"></i> Cab Service in Nigdi Pradhikaran</Link>

<Link className="mx-md-2 d-block" to="/Cab-Service-in-Akurdi"><i className="fa fa-car darkcolor"></i> Cab Service in Akurdi</Link>

          <Link className="mx-md-2 d-block" to="/Cab-Service-in-Wakad-Pune"><i className="fa fa-car darkcolor"></i> Cab Service in Wakad Pune</Link>
<Link className="mx-md-2 d-block" to="/Cab-Service-in-Pimple-Saudagar"><i className="fa fa-car darkcolor"></i> Cab Service in Pimple Saudagar</Link>
<Link className="mx-md-2 d-block" to="/Cab-Service-in-Pimple-Gurav"><i className="fa fa-car darkcolor"></i> Cab Service in Pimple Gurav</Link>
<Link className="mx-md-2 d-block" to="/Cab-Service-in-Ravet"><i className="fa fa-car darkcolor"></i> Cab Service in Ravet</Link>
<Link className="mx-md-2 d-block" to="/Cab-Service-in-Moshi-Pune"><i className="fa fa-car darkcolor"></i> Cab Service in Moshi Pune</Link>
<Link className="mx-md-2 d-block" to="/Cab-Service-in-Chikhali-Pune"><i className="fa fa-car darkcolor"></i> Cab Service in Chikhali Pune</Link>
<Link className="mx-md-2 d-block" to="/Cab-Service-in-Sangvi-Pune"><i className="fa fa-car darkcolor"></i> Cab Service in Sangvi Pune</Link>
<Link className="mx-md-2 d-block" to="/Cab-Service-in-Rahatani"><i className="fa fa-car darkcolor"></i> Cab Service in Rahatani</Link>
<Link className="mx-md-2 d-block" to="/Cab-Service-in-Thergaon"><i className="fa fa-car darkcolor"></i> Cab Service in Thergaon</Link>
<Link className="mx-md-2 d-block" to="/Cab-Service-in-Talawade-Pune"><i className="fa fa-car darkcolor"></i> Cab Service in Talawade Pune</Link>
<Link className="mx-md-2 d-block" to="/Cab-Service-in-Dapoli"><i className="fa fa-car darkcolor"></i> Cab Service in Dapoli</Link>
<Link className="mx-md-2 d-block" to="/Cab-Service-in-Kasarwadi"><i className="fa fa-car darkcolor"></i> Cab Service in Kasarwadi</Link>
<Link className="mx-md-2 d-block" to="/Cab-Service-in-Punawale"><i className="fa fa-car darkcolor"></i> Cab Service in Punawale</Link>
<Link className="mx-md-2 d-block" to="/Cab-Service-in-Tathawade-Pune"><i className="fa fa-car darkcolor"></i> Cab Service in Tathawade Pune</Link>
<Link className="mx-md-2 d-block" to="/Cab-Service-in-Baner-Pune"><i className="fa fa-car darkcolor"></i> Cab Service in Baner Pune</Link>
<Link className="mx-md-2 d-block" to="/Employee-Transportation-Services-Pune"><i className="fa fa-car darkcolor"></i> Employee Transportation Services Pune</Link>
<Link className="mx-md-2 d-block" to="/Office-Cab-Service-Pune"><i className="fa fa-car darkcolor"></i> Office Cab Service Pune</Link>
<Link className="mx-md-2 d-block" to="/Corporate-Taxi-Service-Pune"><i className="fa fa-car darkcolor"></i> Corporate Taxi Service Pune</Link>
<Link className="mx-md-2 d-block" to="/Monthly-Cab-Service-in-Pune"><i className="fa fa-car darkcolor"></i> Monthly Cab Service in Pune</Link>
<Link className="mx-md-2 d-block" to="/Corporate-Bus-Services-in-Pune"><i className="fa fa-car darkcolor"></i> Corporate Bus Services in Pune</Link>
<Link className="mx-md-2 d-block" to="/Cab-Service-for-Corporate-Events-in-Pune"><i className="fa fa-car darkcolor"></i> Cab Service for Corporate Events in Pune</Link>
<Link className="mx-md-2 d-block" to="/Bus-Rental-for-Corporate-Events-in-Pune"><i className="fa fa-car darkcolor"></i> Bus Rental for Corporate Events in Pune</Link>
<Link className="mx-md-2 d-block" to="/Pan-India-Cab-Service-from-Pune"><i className="fa fa-car darkcolor"></i> Pan India Cab Service from Pune</Link>
                  
                  <Link className="mx-md-2 d-block" to="/Latur-to-Pune-Cab-Service">
  <i className="fa fa-car darkcolor"></i> Latur to Pune Cab Service
</Link>

<Link className="mx-md-2 d-block" to="/Kolhapur-to-Pune-Cab-Service">
  <i className="fa fa-car darkcolor"></i> Kolhapur to Pune Cab Service
</Link>

<Link className="mx-md-2 d-block" to="/Pandharpur-to-Pune-Cabs">
  <i className="fa fa-car darkcolor"></i> Pandharpur to Pune Cabs
</Link>

<Link className="mx-md-2 d-block" to="/Solapur-to-Pune-Cab-Service">
  <i className="fa fa-car darkcolor"></i> Solapur to Pune Cab Service
</Link>

<Link className="mx-md-2 d-block" to="/Sambhaji-Nagar-to-Pune-Cabs">
  <i className="fa fa-car darkcolor"></i> Sambhaji Nagar to Pune Cabs
</Link>

<Link className="mx-md-2 d-block" to="/Nashik-to-Pune-Cab-Service">
  <i className="fa fa-car darkcolor"></i> Nashik to Pune Cab Service
</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Jalgaon-Cab-Service">
  <i className="fa fa-car darkcolor"></i> Pune to Jalgaon Cab Service
</Link>

<Link className="mx-md-2 d-block" to="/Pune-to-Dhule-Cab-Service">
  <i className="fa fa-car darkcolor"></i> Pune to Dhule Cab Service
</Link>

<Link className="mx-md-2 d-block" to="/Alibag-to-Pune-Cab">
  <i className="fa fa-car darkcolor"></i> Alibag to Pune Cab
</Link>

<Link className="mx-md-2 d-block" to="/Mahabaleshwar-to-Pune-Cab">
  <i className="fa fa-car darkcolor"></i> Mahabaleshwar to Pune Cab
</Link>

<Link className="mx-md-2 d-block" to="/Lonavala-to-Pune-Cabs">
  <i className="fa fa-car darkcolor"></i> Lonavala to Pune Cabs
</Link>

<Link className="mx-md-2 d-block" to="/Ahilya-Nagar-to-Pune-Cabs">
  <i className="fa fa-car darkcolor"></i> Ahilya Nagar to Pune Cabs
</Link>

<Link className="mx-md-2 d-block" to="/Baramati-to-Pune-Cab">
  <i className="fa fa-car darkcolor"></i> Baramati to Pune Cab
</Link>

<Link className="mx-md-2 d-block" to="/Nagpur-to-Pune-Cab">
  <i className="fa fa-car darkcolor"></i> Nagpur to Pune Cab
</Link>

<Link className="mx-md-2 d-block" to="/Thane-to-Pune-Cab-Service">
  <i className="fa fa-car darkcolor"></i> Thane to Pune Cab Service
</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        {/* </div> */}
      {/* </div> */}

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="copyright">
            <div className="row align-items-center row-gap-3 text-center">
              <div className="col-lg-12">
                <div className="copyright-text">
                    <p className="copyright-text text-white">
              All Rights Reserved &copy;  <span className="darkcolorrr">Srs cabs</span> <span id="date">{new Date().getFullYear()}</span>{' '}
                <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Dexter Intelligence</span>
              </a> | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Urva Hosting</span>
              </a>
              </p>
                </div>
              </div>
            
            
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;